import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
// @ts-ignore
import AssetAcquisition from '@/types/table/assetAcquisition';
// @ts-ignore
import { AssetAcquisitionDetailData } from '@/api/generated/assetAcquisitionDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetAcquisitionData extends AssetAcquisition {
  assetAcquisitionDetailList?: AssetAcquisitionDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetAcquisitionController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetAcquisitionData>>(API_CONTEXT + '/app/assetAcquisition/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetAcquisitionData>(API_CONTEXT + '/app/assetAcquisition/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/assetAcquisition/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/assetAcquisition/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/assetAcquisition/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/deleteBatch', params, httpOptions);
  }
  static startOnlyWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/startOnly/WkcAssetAcquisition', params, httpOptions);
  }
  static startWithBusinessKeyWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/startWithBusinessKey/WkcAssetAcquisition', params, httpOptions);
  }
  static startAndTakeUserTaskWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/startAndTakeUserTask/WkcAssetAcquisition', params, httpOptions);
  }
  static startAndSaveDraftWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/startAndSaveDraft/WkcAssetAcquisition', params, httpOptions);
  }
  static submitUserTaskWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/submitUserTask/WkcAssetAcquisition', params, httpOptions);
  }
  static viewTaskBusinessDataWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/assetAcquisition/viewTaskBusinessData/WkcAssetAcquisition', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/assetAcquisition/viewHistoricTaskBusinessData/WkcAssetAcquisition', params, httpOptions);
  }
  static listWorkOrderWkcAssetAcquisition(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/listWorkOrder/WkcAssetAcquisition', params, httpOptions);
  }

   static revocation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/revocation', params, httpOptions);
  }
    static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

    static getUserInformationByUserId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/getUserInformation', params, httpOptions);
  }
   static getAssetNameUser(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/getAssetNameUser', params, httpOptions);
  }

     static getSysConfiguration(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/getSysConfiguration', params, httpOptions);
  }

    static updateFlowStatusById(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/assetAcquisition/updateFlowStatusById', params, httpOptions);
  }

}
